import styled from 'styled-components/macro'

export const ExampleList = styled.ul`
  margin: 0;
  padding-left: 1.25em;

  > li + li {
    margin-top: 0.35em;
  }
`
